//Style
import '../../styles/cv/profile.scss'

//Images
/* import CvProfilePic from '../../assets/cv_profile_pic.jpg' */
import CvProfileVid from '../../assets/Profile_pic_vid.mp4'
import CvMail from '../../assets/cv_mail_icon.svg'
import CvLocation from '../../assets/cv_location_icon.svg'
import CvMe from '../../assets/cv_me_icon.svg'
import CvSendMail from '../../assets/cv_send_mail_icon.svg'

// Language
import { useLanguage } from '../../context/language_context'


function Profile() {

    const { language } = useLanguage()
    
    return (

        <section className="cv_profile">

            <h3>
                {language === 'fr'
                    ? 'À propos de moi'
                    : 'About me'}
            </h3>


            <nav>

                <ul className='cv_nav_1'>
                    <li>File</li>
                    <li>Edit</li>
                    <li>View</li>
                    <li>Help</li>
                </ul>


                <ul className='cv_nav_2'>

                    <li>
                        <img src={CvLocation} alt="" />

                        {language === 'fr'
                            ? 'France / Corée du Sud'
                            : 'France / South Korea'}
                    </li>

                    <li>
                        <img src={CvMe} alt="" />

                        {language === 'fr'
                            ? 'A spawn le 21/05/1996'
                            : 'Spawned on 21/05/1996'}
                    </li>

                </ul>

            </nav>


            <div className='cv_mail'>

                <p>
                    {language === 'fr'
                        ? 'Adresse'
                        : 'Address'}
                </p>


                <div className='cv_mail_bar'>

                    <img src={CvMail} alt="" />

                    <p>
                        maurineduet@gmail.com
                    </p>

                </div>


                <div className='cv_mail_send'>

                    <img src={CvSendMail} alt="" />

                    <p>Go</p>

                </div>

            </div>


            <video
                autoPlay
                muted
                loop
                src={CvProfileVid}
            />


            <div className='cv_title'>

                <h1>
                    Maurine Duet
                </h1>

                <p>
                    {language === 'fr'
                        ? "Créative et polyvalente, je transforme les idées en projets concrets, de leur conception à leur réalisation, avec une expertise et une curiosité particulièrement tournées vers la Corée du Sud et les jeux vidéo."
                        : "Creative and versatile, I turn ideas into concrete projects from concept to completion, with expertise and a strong interest in South Korea and video games."}
                </p>

            </div>

        </section>

    )
}

export default Profile